module.exports = __webpack_public_path__ + "static/media/Cats Eyes 01_ENGELSKA-mixdown.8490229e.mp3";